import React from 'react';
import classes from "./winter.module.css";
import VideoSection from '../../containers/videoSection/videoSection';
import WelcomeSection from '../welcomeSection/welcomeSection';
import Activities from '../activities/activities';
import Staff from '../staff/staff';
import Sessions from '../sessions/sessions';
import Background from '../../../assets/images/winter-session.png';

const WinterCamp = (props) => {
  return (
    <div className={classes.Container}>
      {/* <VideoSection src="https://www.youtube.com/embed/YOUR_VIDEO_ID" /> */}
      <WelcomeSection title='WELCOME TO WINTER CAMP' isWinter camp='winter' info={props.winterCamp?.info} />
      <Activities title='WINTER ACTIVITIES' activities={props.winterCamp?.activities} isWinter camp='winter' />
      <Staff title='WINTER STAFF' staffData={props.winterCamp?.staff} camp='winter' />
      <Sessions title='SESSIONS' offers={props.winterCamp?.packages} camp='winter'
        extraServices={props.winterCamp?.extra_services}
        setSelectedPlan={props.setSelectedPlan}
        setShowCampRegistrationForm={props.setShowCampRegistrationForm}
        isAuthenticated={props.isAuthenticated} setShowLoginForm={props.setShowLoginForm}
        description={props.winterCamp?.info?.session_text} background={Background}/>
    </div>
  )
}
export default WinterCamp;